import { Link } from "react-router-dom";
import { allCategories } from "@/utils/videoUtils";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-primary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-accent-950">
                <i className="ri-clapperboard-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">日本伦理剧</span>
            </div>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed max-w-md">
              日本伦理剧是一个专注于日本伦理剧情影视内容的展示与介绍平台，汇集经典与最新的伦理电视剧与电影，为影迷、研究者及文化爱好者提供便捷的浏览、检索与推荐服务。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-3">
              <Link to="/category/drama" className="hover:text-accent-400">影视分类</Link>
            </h4>
            <ul className="flex flex-col gap-2">
              {allCategories.map((cat) => (
                <li key={cat.key}>
                  <Link to={`/category/${cat.key}`} className="text-sm text-background-200/80 hover:text-accent-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-3">
              <Link to="/" className="hover:text-accent-400">网站导航</Link>
            </h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors">首页</Link></li>
              <li><Link to="/search" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors">搜索作品</Link></li>
              <li><Link to="/about" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-xs text-background-200/70">
            © {year} 日本伦理剧 · 本站为影视内容浏览展示站，不含真实播放与下载功能
          </p>
          <p className="text-xs text-background-200/70">
            内容仅供学习交流与研究参考
          </p>
        </div>
      </div>
    </footer>
  );
}